import React from "react";
import { Box, Button, Heading, Text, useDisclosure } from "@chakra-ui/react";
import { useOrganization } from "../../hooks/useOrganization";
import { OrganizationInfo } from "../OrganizationInfo";
import { AddOrgModal } from "../AddOrgModal";

export const Organization = ({ user, isTeacher }) => {
  const { userOrganization } = useOrganization(user);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      <Heading as="h3" style={{ margin: "20px 0 0", fontSize: "20px" }}>
        School / Organization:
      </Heading>
      {!userOrganization?.organization?.id && (
        <Box>
          <Text style={{ padding: "10px 0" }}>
            You haven't added any organization yet. Please add to create classes
            and adding students.
          </Text>
          <Button
            colorScheme="brand"
            _hover={{
              bg: "blue.500",
            }}
            onClick={onOpen}
          >
            Add Organization
          </Button>
        </Box>
      )}
      {userOrganization?.organization?.id && (
        <OrganizationInfo organization={userOrganization?.organization} />
      )}
      <AddOrgModal
        user={user}
        isTeacher={isTeacher}
        onClose={onClose}
        isOpen={isOpen}
      />
    </Box>
  );
};
